import EditRequester from './EditRequester';

export default EditRequester;
